import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IConfirmationInput {
  title: string;
  text: string;
  /** Optional second paragraph, shown in red under the main text. */
  warningText?: string;
  confirmBtnText?: string;
  confirmBtnClass?: string;
  cancelBtnText?: string;
  cancelBtnClass?: string;
  reverseBtn?: boolean;
  /**
   * When set, the dialog shows a mandatory reason field. Confirm stays
   * disabled until a non-blank reason is entered, and the dialog closes with
   * the trimmed reason string instead of `true`.
   */
  reasonLabel?: string;
}

@Component({
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  public reason = '';

  public get confirmBtnText(): string {
    return this.data.confirmBtnText ?? 'Ok';
  }
  public get confirmBtnClass(): string {
    return this.data.confirmBtnClass ?? 'mat-accent-200-bg';
  }

  public get cancelBtnText(): string {
    return this.data.cancelBtnText ?? 'Cancel';
  }
  public get cancelBtnClass(): string {
    return this.data.cancelBtnClass ?? 'mat-grey-200-bg';
  }

  public get requiresReason(): boolean {
    return !!this.data.reasonLabel;
  }

  public get isReasonValid(): boolean {
    return this.reason.trim().length > 0;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationInput,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) { }

  public confirmWithReason(): void {
    if (!this.isReasonValid) {
      return;
    }
    this.dialogRef.close(this.reason.trim());
  }
}
